module.exports = __webpack_public_path__ + "img/logo_kitkitphase3@0.5x.06b07f4e.png";